import { Children, ReactNode } from 'react'
import style from '../../style.module.scss'

type Props = {
  title?: string
  children?: ReactNode
}

export function Section(props: Props) {
  const validChildren = Children.toArray(props.children).filter(Boolean)

  if (validChildren.length === 0) return null

  return (
    <section className={style.section}>
      {props.title && <h6 className={style.sectionHeading}>{props.title}</h6>}
      <div className={style.content}>{props.children}</div>
    </section>
  )
}
